import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { ticketType } from '../../../constants/ticketType';
import BetListNg from './BetListNg';
import BetGroupNg from './BetGroupNg';
import './BetListNg.less';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';
import BetLoader from '../BetLoader';

function BetsNg({ ticket, bets }) {
    const ticketNumber = ticket.get('ticketNumber');
    const type = ticket.get('type');

    if (!ticketNumber) {
        return <MultipleComponentsLoader componentLoader={BetLoader} itemsCount={2} />;
    }
    if (type === ticketType.System) {
        return (
            <div className="ticket-detail-group-list">
                {groupBets(bets)
                    .map(group => (
                        <BetGroupNg
                            key={group.get('name')}
                            name={group.get('name')}
                            ticket={ticket}
                            bets={group.get('bets')}
                        />
                    ))
                    .toList()}
            </div>
        );
    }

    return <BetListNg ticket={ticket} bets={bets} />;
}

export const groupBets = bets => {
    return bets
        ? bets
              .groupBy(bet => bet.get('group'))
              .map(betsList => Immutable.fromJS({ bets: betsList, name: betsList.getIn([0, 'group']) }))
              .sortBy(group => group.get('name'))
        : Immutable.List();
};

BetsNg.propTypes = {
    ticket: PropTypes.instanceOf(Immutable.Map),
    bets: PropTypes.instanceOf(Immutable.List)
};

export default BetsNg;
